var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 0.245483C6.86428 0.245483 0.245483 6.86464 0.245483 15.0001C0.245483 23.1355 6.86464 29.7546 15.0004 29.7546C23.1358 29.7546 29.7546 23.1355 29.7546 15.0001C29.7546 6.86464 23.1358 0.245483 15.0004 0.245483ZM17.5378 21.0467C19.8344 19.3023 21.4443 15.5234 21.4443 12.8654C21.4443 9.30657 18.5589 6.42151 14.9997 6.42151C11.4413 6.42151 8.55621 9.30657 8.55621 12.8654C8.55621 15.5234 10.1657 19.3023 12.4627 21.0467C9.27657 21.4584 6.7338 22.6269 5.695 24.1287C3.38392 21.7746 1.95548 18.5516 1.95548 15.0001C1.95548 7.80765 7.80729 1.95548 15.0004 1.95548C22.1928 1.95548 28.0446 7.80729 28.0446 15.0001C28.0446 18.5516 26.6162 21.7746 24.3051 24.1295C23.2663 22.6273 20.7236 21.4584 17.5378 21.0467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactlogo);
export default __webpack_public_path__ + "static/media/contactlogo.b5705b3b5e97cdc65d45a8ee31c85c3b.svg";
export { ForwardRef as ReactComponent };